<template>
<div class="storyResultSpecial yearluckResultBase"
  :data-loading="isLoading"
>
  <div class="sh-result__top">
    <!-- タイトル -->
    <div class="storyResult__header">
      <div class="storyResult__menu">
        <uranai-img
          data-clip-path-support="true"
          data-size="md"
          size="md"
          :src="item.pack_image"
          :alt="item.item_name"
          class="u-mg-r-1"
        ></uranai-img>
        <div>
          <div class="storyResult__menu__content">
            <h1>{{ item.item_name }}</h1>
            <div class="tagarea">
              <span class="badge">{{item.service_type_str}}</span>
              <span class="badge u-tag"
                v-if="item.category_tag_name"
              >{{item.category_tag_name}}</span>
              <span
                v-if="optionalTagName"
                :class="'badge limited u-opttag-'+optionalTagId"
              >{{ optionalTagName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { FORMAT } from '@/CONSTS'

export default {
  name: 'story-result-second-half',
  data() {
    return {
      FORMAT,
      isLoading: false,
      errorMessage: null
    }
  },
  props: {
    itemsId: String,
    itemName: String,
    menuName: String,
    packImage: String,
    optionalTagName: { type: String, default: '' },
    optionalTagId: { type: [Number,String], default: null }
  },
  computed: {
    ...mapState({
      item: state => state.item.selected
    })
  },
  mounted() {
    this.isLoading = true
    this.$store.dispatch(type.RESET_SELECTED_ITEM)
    this.$store
      .dispatch(type.SELECT_ITEM, { id: parseInt(this.itemsId, 10) }) // 00000nの形式で渡るのでparseIntする
      .then(this.handleSelectItemSuccess)
      .catch(this.handleSelectItemError)
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    setZeroNumber(num){ // 0埋めをして2けた数字にする
      return ('00' + num).slice(1);
    }
  }
}
</script>
<style lang="scss" scoped>
.storyResult {
  &__menu {
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: 11px 4px;
    .uranaiImg[data-size='md'] {
      min-width: 88px;
    }
    &__content {
      min-height: 88px;
      width: 100%;
      display: table;

      h1 {
        color: #141414;
        font-size: 13px;
        line-height: 16px;
        margin: 0;
      }
      p {
        font-size: 11px;
        line-height: 18px;
        margin: 4px 0;
      }
      .limited {
        color: #ed1e79;
        border-color: #ed1e79;
      }
      &__bottomBox {
        padding: 20px 12px 0;
      }
    }
  }
  &__counselorArea {
    overflow: hidden;
    text-align: left;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ededed;
    border-top: 1px solid #ededed;
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      margin-right: 12px;
    }
  }
}

.tagarea {
  display: table;
  margin-top: 4px;
}

.counselorname {
  line-height: 13px;
  margin-top: 17px;
  font-size: 13px;
  letter-spacing: 1px;
  color: #141414;
}

.profile {
  line-height: 16px;
  margin-top: 0;
  font-size: 12px;
  color: #676767;
}
.storyResultSpecial {
  &.yearluckResultBase {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/yearluckResultTop.vue